export default __webpack_public_path__ + "static/media/btn-bullet.a9b9c5b4.png";